import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPinOpen = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.1236 9.87598L1.5 14.4996M3.92575 6.1421C3.81145 6.20916 3.71405 6.30154 3.64105 6.41214C3.56804 6.52275 3.52137 6.64862 3.50463 6.78008C3.4879 6.91154 3.50153 7.04509 3.54449 7.17046C3.58744 7.29582 3.65858 7.40967 3.75243 7.50324L8.49735 12.2482C8.59092 12.342 8.70477 12.4131 8.83013 12.4561C8.9555 12.4991 9.08905 12.5127 9.22051 12.496C9.35197 12.4792 9.47784 12.4325 9.58845 12.3595C9.69905 12.2865 9.79143 12.1891 9.85849 12.0748C10.4205 11.1079 10.5881 9.96155 10.3265 8.8742L14.0985 6.47371C14.208 6.40407 14.3004 6.31073 14.369 6.20058C14.4376 6.09043 14.4806 5.96628 14.4948 5.83729C14.509 5.7083 14.494 5.57778 14.451 5.45534C14.408 5.33291 14.3381 5.22169 14.2464 5.12991L10.8707 1.75421C10.7789 1.66246 10.6678 1.59248 10.5453 1.54943C10.4229 1.50639 10.2924 1.49139 10.1634 1.50553C10.0345 1.51967 9.9103 1.56259 9.80012 1.63113C9.68994 1.69967 9.59656 1.79208 9.52688 1.90153L7.12639 5.67413C6.03904 5.41246 4.89267 5.58007 3.92575 6.1421Z",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgPinOpen;
